export default __webpack_public_path__ + "static/media/confesiones1.148efbbc.png";